//********************************************************************** //
// More info here: https://developer.crowdin.com/in-context-localization //
//********************************************************************** //
import { useTranslations } from "ilenia";
import React from "react";

import { crowdinLocale } from "../../utils/locale";

const makeCrowdinProjectId = (): string => {
  const searchParams = new URLSearchParams(window.location.search);
  const crowdinProjectOverride = searchParams.get("crowdinProjectOverride");

  if (crowdinProjectOverride) {
    return crowdinProjectOverride;
  }

  const projectsMapping = {
    "/reviews": "trustpilot-businessapp-microsites",
    "/settings": "trustpilot-businessapp-microsites",
    "/onboarding": "trustpilot-businessapp-microsites",
    "/dashboard": "trustpilot-businessapp-microsites",
    "/benchmark": "trustpilot-businessapp-microsites",
    "/insights": "trustpilot-businessapp-microsites",
    "/analytics": "trustpilot-statistics-business",
    "/invitations": "trustpilot-b2binvitationsapp",
    "/review-insights": "trustpilot-sentiment-businessa",
    "/reach": "trustpilot-reach-businessapp",
    "/integrations": "trustpilot-b2bintegrationsapp",
    "/product-reviews": "trustpilot-b2bproductreviews",
    "/marketing": "trustpilot-marketing-businessa",
    "/webhooks": "trustpilot-extwebhooks-busines",
    "/share": "b2b-integrations-socialapp-int",
    "/applications": "applications-businessapp",
  };

  const [, value] = Object.entries(projectsMapping).find(([key]) => window.location.pathname.startsWith(key)) || [
    "/",
    "trustpilot-businessapp-shell",
  ];

  return value;
};

const initCrowdin = () =>
  new Promise((resolve, reject) => {
    const w = window as any;
    w._jipt = [];
    w._jipt.push(["project", makeCrowdinProjectId()]);

    const script = document.createElement("script");
    script.type = "text/javascript";
    script.id = "crowdin-in-context";
    script.defer = true;

    script.addEventListener("load", resolve);
    script.addEventListener("error", (e) =>
      reject(new Error(`Failed to insert crowdin in-context translation script.${e}`)),
    );

    script.src = "//cdn.crowdin.com/jipt/jipt.js";
    document.head.appendChild(script);
  });

export const CrowdinInContext = () => {
  const [, locale] = useTranslations();
  React.useEffect(() => {
    if (locale === crowdinLocale) {
      initCrowdin();
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return <React.Fragment />;
};
